<template>
  <div>
    <div class="vx-row" id="formulation_customer_related_data_form">
      <div class="vx-col w-full">
        <vx-card no-shadow>
          <template slot="actions">
            <vs-button v-if="$canAll(formulationPermissions)" @click="onClickSave()" class="mr-0" color="primary" size="small"
                       type="filled">Save Changes
            </vs-button>
          </template>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="formulation.notes" height="150px" />
              </ValidationProvider>
            </div>
          </div>

        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
import moment from 'moment/src/moment'
import vSelect from "vue-select";

export default {
  name: "FormulationNotesTab",
  data() {
    return {
      formulationId: '',
      project_briefs: [],
    }
  },
  props: {
    formulation_data: {
      type: Object,
      default: {},
    },
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async onClickSave() {
      await this.$vs.loading({
        container: '#formulation_customer_related_data_form',
        scale: 0.45
      })
      try {
        const payload = {
          name: this.formulation.name,
          legal_name: this.formulation.legal_name,
          batch_weight: this.formulation.batch_weight,
          notes: this.formulation.notes,
          formulation_type: this.formulation.formulation_type,
          is_kosher: this.formulation.is_kosher,
          is_halal: this.formulation.is_halal,
        }
        await FormulationsRepository.updateFormulation(this.formulationId, payload)
        await this.$emit('refreshGeneral', '')
        this.showSuccessMessage('Formulation Updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formulation_customer_related_data_form > .con-vs-loading')
    }
  },
  async mounted() {
    this.formulationId = this.$route.params.id
  },
  computed: {
    formulation: function () {
      return this.formulation_data
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
}
</script>

<style scoped>

.__table-heading-small {
  /*font-size: x-small;*/
  /*font-weight: normal;*/
}

</style>
